import React, { Component } from 'react'
import PropTypes from 'prop-types';
import CommonReport from '../../CommonReport'
export class CDR extends Component {
  render() {
    return (
      <CommonReport/>
    )
  }
}
CDR.contextTypes = {
  __: PropTypes.func
};

export default CDR;



// WEBPACK FOOTER //
// src/modules/screens/reporting/CDR/components/CDR.js